import { Link } from 'react-router-dom';
import { useAuth, homeFor } from '../context/AuthContext.jsx';
import CyberCubLogo from './CyberCubLogo.jsx';
import ThemeToggle from './ThemeToggle.jsx';
import HelpBot from './HelpBot.jsx';

/**
 * The header and footer every public page wears.
 *
 * Extracted the moment there was a second public page, because a nav
 * kept in two files is a nav that disagrees with itself by the third
 * change.
 *
 * The section links are the awkward part: they point at anchors that
 * only exist on the homepage. From anywhere else they have to be
 * "/#courses" so the browser goes home first and then scrolls, which
 * is what `onHome` decides.
 */
export default function PublicShell({ onHome = false, children }) {
  const { user } = useAuth();

  return (
    <div className="home">
      <header className="home-nav">
        {onHome ? (
          <a className="home-brand" href="#top">
            <CyberCubLogo size={40} />
            <span className="brand-name">
              Cyber<span className="brand-name-alt">Cub</span>
            </span>
          </a>
        ) : (
          <Link className="home-brand" to="/">
            <CyberCubLogo size={40} />
            <span className="brand-name">
              Cyber<span className="brand-name-alt">Cub</span>
            </span>
          </Link>
        )}

        <nav className="home-nav-links" aria-label="Sections">
          <Link to="/about">About</Link>
          <Link to="/cyberpath">CyberPath</Link>
          <Link to="/leaderboard">Leaderboard</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        <div className="home-nav-actions">
          <ThemeToggle />
          {user ? (
            <Link to={homeFor(user.role)} className="btn btn-sm">
              My courses →
            </Link>
          ) : (
            <>
              <Link to="/login" className="btn btn-sm">Log in</Link>
            </>
          )}
        </div>
      </header>

      {children}

      <footer className="home-foot">
        <div className="home-foot-brand">
          <CyberCubLogo size={30} />
          <span>CyberCub</span>
        </div>
        <nav className="home-foot-links" aria-label="Account">
          <Link to="/about">About</Link>
          <Link to="/cyberpath">CyberPath</Link>
          <Link to="/leaderboard">Leaderboard</Link>
          <Link to="/contact">Contact</Link>
          {user ? (
            <Link to={homeFor(user.role)}>My courses</Link>
          ) : (
            <>
              <Link to="/login">Log in</Link>
            </>
          )}
        </nav>
        <span className="home-foot-note">Learn to stay safe online · Ages 7+</span>
      </footer>

      <HelpBot />
    </div>
  );
}
